export namespace RestrictionCategoryId {
  export const Deposit = 1n; // Depósito
  export const Withdrawal = 2n; // Saque
  export const Stake = 3n; // Aposta
  export const Spend = 4n; // Perda
  export const TimePlayed = 5n; // Tempo jogado
}

export type RestrictionCategoryType =
  (typeof RestrictionCategoryId)[keyof typeof RestrictionCategoryId];
